import script from "./CourseSubjectItemPages.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseSubjectItemPages.vue?vue&type=script&setup=true&lang=js"

import "./CourseSubjectItemPages.vue?vue&type=style&index=0&id=76ad0a6c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ad0a6c"]])

export default __exports__